import React from 'react';
import Utils from '@/utils/util';
import { AppointmentData, Business } from '../types';
export type RangeDisplayProps = {
  business?: Business;
  startDate?: Date;
  endDate?: Date;
  showTime?: boolean;
  appointmentData: AppointmentData
};

export const RangeDisplay = ({ business, startDate, endDate, showTime, appointmentData }: RangeDisplayProps) => {
  return (
    <div className="range-display">
      <div className="date-disp start">
        <h6>
          {startDate && Utils.formatDateStringTz(startDate, undefined, 'MMM DD, yyyy')}{' '}
          {Utils.getTimeLabel(appointmentData.selectedLocation?.boardingCheckIn).replace(/\s+/g, '').toLowerCase()}
        </h6>
        <span>Check-in Time</span>
      </div>
      <div className="date-disp end">
        <h6>
          {endDate && Utils.formatDateStringTz(endDate, undefined, 'MMM DD, yyyy')}{' '}
          {Utils.getTimeLabel(appointmentData.selectedLocation?.boardingCheckOut).replace(/\s+/g, '').toLowerCase()}
        </h6>
        <span>Check-out Time</span>
      </div>
    </div>
  );
};
